export default {
  updateTenant (state, tenant) {
    if (tenant !== undefined && tenant !== '' && tenant !== state.tenant) {
      if (tenant === 'msb' || tenant === 'smart') {
        state.tenant = tenant
      } else {
        state.tenant = 'smart'
      }

      if (tenant === 'msb') {
        state.tenant_full_name = 'MainStreet Bank'
      } else {
        state.tenant_full_name = 'SMART Payment Plan'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js